import { forwardRef } from "react";
import { FiAlertOctagon } from "../../assets/icons/vander";

export const ErrorMessage = forwardRef(({ children, className }, ref) => {
  return (
    <div
      ref={ref}
      className={`alert bg-soft-danger fw-medium mb-0 ${className}`}
      role="alert"
    >
      <FiAlertOctagon className="fs-5 align-middle me-1" /> {children}
    </div>
  );
});
